/**
 * ServiceTechnicalDetailsCard — the "Technical Details" card on the Service
 * Detail page. Purely presentational. Extracted from
 * `routes/services/$serviceId.tsx` (issue #1411).
 */
import type { Service } from '../../graphql/types';

const CardElement = 'forge-card' as React.ElementType;
const DividerElement = 'forge-divider' as React.ElementType;

export interface ServiceTechnicalDetailsCardProps {
  service: Service;
}

export function ServiceTechnicalDetailsCard({
  service,
}: ServiceTechnicalDetailsCardProps): JSX.Element {
  return (
    <CardElement className="service-card">
      <div className="card-header">
        <h2 className="forge-typography--headline6">Technical Details</h2>
      </div>
      <DividerElement />
      <div className="card-content">
        <div className="detail-row">
          <span className="detail-label">Entity ID</span>
          <span className="detail-value detail-value-code">{service.entityId}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Repository</span>
          <span className="detail-value">
            {service.repo ? (
              <a href={service.repo} target="_blank" rel="noopener noreferrer">
                {service.repo}
              </a>
            ) : (
              '—'
            )}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Website</span>
          <span className="detail-value">
            {service.url ? (
              <a href={service.url} target="_blank" rel="noopener noreferrer">
                {service.url}
              </a>
            ) : (
              '—'
            )}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Schema Version</span>
          <span className="detail-value">{service._schemaVersion}</span>
        </div>
      </div>
    </CardElement>
  );
}
